import React from "react";
import {
    BlockQuote,
    GoToAction,
    Cite,
    Deck,
    Heading,
    ListItem,
    List,
    Quote,
    Slide,
    Text
} from "spectacle";
import Button from '../components/Button';

const PersonalizationBootcamp = () =>
    <div>
        <Heading size={6} textColor="fifth" caps>
            Sitecore Personalization Boot camp
        </Heading>
        <Text textSize={30} textColor="primary">
            Learn everything about personalization; from segmentation to individualization, powered by real-time data and AI.
        </Text>
        <List ordered textColor="primary" style={{paddingLeft: '25px', listStylePosition: 'outside'}}>
            <ListItem textSize={25}>Demystify personalization tactics and strategies</ListItem>
            <ListItem textSize={25}>Understand which critical data points are needed to drive personalization for your customers; including how to collect it</ListItem>
            <ListItem textSize={25}>Establish a roadmap for personalization (crawl, walk, run, fly)</ListItem>
            <ListItem textSize={25}>Identify scenarios where personalization can add value to optimize current digital experiences</ListItem>
            <ListItem textSize={25}>Learn how to personalize the experience across channels using different personalization tactics</ListItem>
        </List>
        <Button targetUrl='https://altola.co/bootcamps/personalization' />
    </div>

export default PersonalizationBootcamp;


// WEBPACK FOOTER //
// ./src/slides/PersonalizationBootcamp.js